/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { createBrowserRouter } from "react-router";
import { PublicShell, AppShell } from "./App.shells";
import { VistoryPublicShell } from "./App.vistoryShell";
import { CallbackShell } from "@layout/providers/CallbackShell";
import { SupportAccessShell } from "@/features/support-access/SupportAccessShell";

export const router = createBrowserRouter([
  {
    path: "/p/:agency_slug/:property_slug",
    element: <PublicShell />,
  },
  {
    // The public vistory approval link. It was declared only in App.tsx's
    // `Main`, which nothing imports — so the link 404'd against the catch-all
    // while the four backend endpoints and all four pages sat there working.
    // Wired here [Fase 7, D6] because vistorias survive the rent extermination
    // and this is the flow the person being inspected actually opens.
    //
    // `/vistory/`, not `/v/` [Plano pós-aluguel, D8]: `build_public_link`
    // composes `{FRONTEND_URL}/vistory/{token}`, so every link ever sent
    // by email or WhatsApp points here, and the short path was never
    // emitted by any code — it never had a single user. Changing the
    // backend instead would have broken links already in the world to
    // satisfy an internal doc; doc 017 is what got corrected.
    path: "/vistory/:token",
    element: <VistoryPublicShell />,
  },
  {
    path: "/authentication/callback",
    element: <CallbackShell />,
  },
  {
    // Sauron's "acessar como cliente" link: installs a support session from
    // the URL fragment, so it must sit outside the authenticated /app tree.
    path: "/app/support-access",
    element: <SupportAccessShell />,
  },
  {
    path: "*",
    element: <AppShell />,
  },
]);
